//noScroll
class TopModal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    console.log("aa");

    /****************************
      モーダル表示
     ****************************/

    // モーダルを取得
    const modal = document.getElementById("modal");
    // モーダルを表示するボタンを全て取得
    const openModalBtns = document.querySelectorAll(".js-open-modal");
    // モーダルの中身
    const modalInners = document.querySelectorAll(".js-modal-inner");
    // モーダルを閉じるボタンを全て取得
    const closeModalBtns = document.querySelectorAll(".js-close-modal");
    // モーダル 前後
    const closeModalPrevNext = document.querySelectorAll(".js-modal-prev, .js-modal-next");
    
    // モーダルを表示するボタンをクリックしたとき
    openModalBtns.forEach((openModalBtn, index) => {
      openModalBtn.addEventListener("click", () => {
        let elIndex = index;
        if(openModalBtn.classList.contains('js-open-modal-sp')) {
          elIndex = index - modalInners.length;
        }
        modalInners[elIndex].classList.add("is-active");
        $('.js-modal-next, .js-modal-prev').css({'opacity': '1'});
        if(!modalInners[elIndex].nextElementSibling) {
          $('.js-modal-next').css({'opacity': '0'});
        }
        if(!modalInners[elIndex].previousElementSibling) {
          $('.js-modal-prev').css({'opacity': '0'});
        }
        console.log(modalInners[elIndex].nextElementSibling);
        console.log(modalInners[elIndex].previousElementSibling);
        modal.classList.add("is-active");
        body.classList.add("is-fixed")
      });
    });

    // モーダルを閉じるボタンをクリックしたとき
    closeModalBtns.forEach((closeModalBtn) => {
      closeModalBtn.addEventListener("click", () => {
        modalInners.forEach((modalInner) => {modalInner.classList.remove("is-active");})
        modal.classList.remove("is-active");
        body.classList.remove("is-fixed")
      });
    });

    // モダール 次へ・前へ
    closeModalPrevNext.forEach((_el) => {
      _el.addEventListener("click", (__el) => {
        let elIndex;
        modalInners.forEach((modalInner, index) => {
          if(modalInners[index].classList.contains("is-active")) {
            elIndex = __el.target.classList.contains('js-modal-next') ? index + 1 : index - 1;
            if(modalInners[elIndex]) {
              modalInners[index].classList.remove("is-active");
            }
          }
        })
        if(modalInners[elIndex]) {
          modalInners[elIndex].classList.add("is-active");
          if(!modalInners[elIndex].nextElementSibling) {
            $('.js-modal-next').css({'opacity': '0'});
          } else if(!modalInners[elIndex].previousElementSibling) {
            $('.js-modal-prev').css({'opacity': '0'});
          } else {
            $('.js-modal-next, .js-modal-prev').css({'opacity': '1'});
          }
        }
      });
    })

    const interviewModalsTrigger = document.querySelectorAll(".js-interview-modalTrigger")
    const interviewModals = document.querySelectorAll(".js-interview-modal")
    const interviewModalsClose = document.querySelectorAll(".js-interview__modal-close")
    const body = document.querySelector("body")



    interviewModalsTrigger.forEach((modalTrigger, index) => {

      modalTrigger.addEventListener("click", () =>{
        if(index === 0){
          interviewModals[0].classList.add("is-active")
        }else if(index === 1){
          interviewModals[1].classList.add("is-active")
        }
        body.classList.add("is-fixed")
      })

      interviewModalsClose.forEach((closeBtn, index) => {
        closeBtn.addEventListener("click", () => {
          if(index === 0){
            interviewModals[0].classList.remove("is-active")
          }else if(index === 1){
            interviewModals[1].classList.remove("is-active")
          }
          body.classList.remove("is-fixed")
        })
      })



    })

    // interviewModalsClose.forEach((closeBtn, index) => {
    //   closeBtn.addEventListener("click", () =>{
    //     console.log("click");

    //     console.log(interviewModalsTrigger[0]);

    //     if(index === 0){
    //       interviewModalsTrigger[0].classList.remove("is-active")
    //     }else if(index === 1){
    //       interviewModalsTrigger[1].classList.remove("is-active")
    //     }
    //   })
    // })


  }
}
